import { apiClient } from '../../../v4/core/apiClient';
import { createSystemSettingsApi } from './system-settings.api.http';

export const mySystemSettingsApi = createSystemSettingsApi(apiClient);
